import type { Describe } from '../lib/abi';
import { hexToBig } from '../lib/abi';
import { sharesPerToken } from '../lib/format';

export function DescribeRows({ d }: { d: Describe }) {
  return (
    <>
      <dt>official</dt><dd>{d.official ? <span className="tick">true</span> : <span className="cross">false</span>}</dd>
      <dt>symbol</dt><dd>{d.symbol ? d.symbol : '(empty)'}</dd>
      <dt>name</dt><dd>{d.name ? d.name : '(empty)'}</dd>
      <dt>uid</dt><dd>{hexToBig(d.uid) === 0n ? '0x0 (zero)' : d.uid}</dd>
      <dt>uiMultiplier</dt><dd>{sharesPerToken(d.uiMultiplier)} (raw {d.uiMultiplier.toString()})</dd>
      <dt>tokenPaused</dt><dd>{String(d.tokenPaused)}</dd>
      <dt>oraclePaused</dt><dd>{String(d.oraclePaused)}</dd>
    </>
  );
}
